import { Sidemenu } from "@/components/Layout/Sidemenu/Sidemenu";

export const OnboardingSidemenu = () => (
  <div className="hidden xl:block">
    <Sidemenu />
  </div>
);
